export default function TooltipNameFirst(value: string) {
    return value.length > 34 ? `${value.slice(0, 34)}...` : value;
}
